import { AiAssistantConfiguration, AiAssistantConfigurationQuery } from '@dreryk/egabinet-ai-assistant-frontend-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

type UseAiAssistantConfigurationQueryOptions = Readonly<{ enabled: boolean }>;

export const useAiAssistantConfigurationQuery = (
   options: UseAiAssistantConfigurationQueryOptions
): UseCqrsQueryResult<AiAssistantConfiguration> => {
   return useCqrsGet<AiAssistantConfiguration>(() => new AiAssistantConfigurationQuery(), {
      enabled: options.enabled,
   });
};
